<template>
    <aside class="zs-sidebar">
        <!-- Brand header — sidebar IS the app switcher, no popover here. -->
        <!-- "Zyno" extralight + rootAppName medium, mirrors c-logo.vue. -->
        <div class="zs-sidebar__brand">
            <!-- Drop the sub-app suffix from the sidebar wordmark — the canvas breadcrumb
                 below already shows it. Sidebar shows just the root product identity. -->
            <div class="zs-sidebar__brand-name" @click="$router.push('/')">
                Zyno<strong>{{ rootStore.rootAppName ?? 'Suite' }}</strong>
            </div>
        </div>

        <!-- Status dock + app nav are hidden on minimal-sidebar routes
             (e.g. workstation registration), leaving only Help + user menu. -->
        <template v-if="!route.meta.minimalSidebar">
            <!-- Status dock — phone, check-ins, notifications. -->
            <SidebarDock />

            <!-- Apps section -->
            <SidebarNav />
        </template>

        <!-- With the nav hidden there's no flexible region to push the footer down,
             so a spacer keeps the user strip + version pinned to the bottom. -->
        <div v-else class="zs-sidebar__spacer"></div>

        <!-- Util rows -->
        <div v-if="updateAvailable" class="zs-util-row has-update" @click="doUpdate">
            <i class="fa-solid fa-arrow-up" />
            <span class="zs-util-row__lbl">Update available</span>
            <span class="zs-util-row__ct">Restart</span>
        </div>
        <!-- Upsell prompt — admins only, and only when the tenant is missing a module. -->
        <div v-if="upsell.show" class="zs-util-row" @click="openDoMore">
            <i class="fa-regular fa-sparkles" />
            <span class="zs-util-row__lbl">Do more with ZynoSuite</span>
            <span class="zs-util-row__ct">+{{ upsell.missing.length }}</span>
        </div>
        <div class="zs-util-row" @click="openHelp">
            <i class="fa-regular fa-circle-question" />
            <span class="zs-util-row__lbl">Help</span>
            <span class="zs-util-row__ct">?</span>
        </div>

        <!-- User strip (hidden in-app) + env/version strip (always shown). -->
        <SidebarUser />
        <SidebarVersion />
    </aside>
</template>

<script lang="ts" setup>
import { presentOverlay } from '@zyno-io/vue-foundation';
import { useRoute } from 'vue-router';

import { useUpsellState } from '@/modules/core/exports/upsell-modules';
import { openHelp } from '@/shared/helpers/help.helpers';
import { useUpdateAvailableRef } from '@/shared/helpers/update.helpers';
import MDoMore from '@/shared/modals/m-do-more.vue';
import { useStore } from '@/store';

import SidebarDock from './sidebar/c-sidebar-dock.vue';
import SidebarNav from './sidebar/c-sidebar-nav.vue';
import SidebarUser from './sidebar/c-sidebar-user.vue';
import SidebarVersion from './sidebar/c-sidebar-version.vue';

const rootStore = useStore();
const route = useRoute();

const updateAvailable = useUpdateAvailableRef();
const upsell = useUpsellState();

function doUpdate() {
    location.reload();
}

function openDoMore() {
    presentOverlay(MDoMore, {});
}
</script>
